"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _datePicker = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/date-picker"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _getPillDisplayValue = function getPillDisplayValue(_ref, items) {
  var condition = _ref.condition,
      type = _ref.type,
      data = _ref.data,
      unit = _ref.unit;

  var formatDate = function formatDate(date) {
    return (0, _dateFormatting.default)(new Date(date).getTime() / 1000 | 0);
  };

  var item = items.find(function (i) {
    return i.value === condition;
  });
  var displayCondition = item === null || item === void 0 ? void 0 : item.name;
  var displayValue;

  switch (type) {
    case 'absolute':
      displayValue = formatDate(data);
      break;

    case 'relative':
      // @ts-expect-error Operator '>' cannot be applied to types 'string | number | IsoDateRange' and 'number'
      displayValue = "".concat(data, " ").concat(unit).concat(data > 1 ? 's' : '', " ago");
      break;

    case 'range':
      displayCondition = '';
      displayValue = "".concat(formatDate(data.from), " - ").concat(formatDate(data.to));
  }

  return "".concat(displayCondition, " ").concat(displayValue);
};

var DateFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DateFilterSelector, _Component);

  var _super = _createSuper(DateFilterSelector);

  function DateFilterSelector() {
    var _this$props$selectedF, _this$props$selectedF2, _this$props$selectedF3, _this$props$selectedF4, _this$props$selectedF5, _this$props$selectedF6, _this$props$selectedF7, _this$props$selectedF8;

    var _this;

    (0, _classCallCheck2.default)(this, DateFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      condition: (_this$props$selectedF = (_this$props$selectedF2 = _this.props.selectedFilterItems) === null || _this$props$selectedF2 === void 0 ? void 0 : _this$props$selectedF2.condition) !== null && _this$props$selectedF !== void 0 ? _this$props$selectedF : '',
      data: (_this$props$selectedF3 = (_this$props$selectedF4 = _this.props.selectedFilterItems) === null || _this$props$selectedF4 === void 0 ? void 0 : _this$props$selectedF4.data) !== null && _this$props$selectedF3 !== void 0 ? _this$props$selectedF3 : '',
      type: (_this$props$selectedF5 = (_this$props$selectedF6 = _this.props.selectedFilterItems) === null || _this$props$selectedF6 === void 0 ? void 0 : _this$props$selectedF6.type) !== null && _this$props$selectedF5 !== void 0 ? _this$props$selectedF5 : '',
      unit: (_this$props$selectedF7 = (_this$props$selectedF8 = _this.props.selectedFilterItems) === null || _this$props$selectedF8 === void 0 ? void 0 : _this$props$selectedF8.unit) !== null && _this$props$selectedF7 !== void 0 ? _this$props$selectedF7 : ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCondition", function (condition, itemType) {
      var _this$state = _this.state,
          data = _this$state.data,
          type = _this$state.type;
      var alreadyAppliedFilter = _this.props.selectedFilterItems; // eslint-disable-next-line no-nested-ternary

      var newData = type === itemType ? data : (alreadyAppliedFilter === null || alreadyAppliedFilter === void 0 ? void 0 : alreadyAppliedFilter.type) === itemType ? alreadyAppliedFilter === null || alreadyAppliedFilter === void 0 ? void 0 : alreadyAppliedFilter.data : '';

      _this.setState({
        condition: condition,
        data: newData,
        type: itemType
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setData", function (data, item) {
      var condition = _this.state.condition;

      _this.setState({
        condition: condition,
        data: data,
        unit: item.type === 'relative' && item.unit
      });
    });
    return _this;
  }

  (0, _createClass2.default)(DateFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          items = _this$props.items,
          children = _this$props.children;
      var _this$state2 = this.state,
          condition = _this$state2.condition,
          data = _this$state2.data,
          type = _this$state2.type;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, items.map(function (item) {
        var checked = condition === item.value && type === item.type;
        var showCalendar = item.type === 'absolute' || item.type === 'range';
        return (0, _preact.h)("div", {
          key: item.id
        }, (0, _preact.h)(_InputGroup.default, {
          inline: true,
          key: item.id,
          name: name,
          value: item.value,
          title: item.name,
          type: "radio",
          formGroupClasses: "overview__filters-box-filter",
          checked: checked,
          onChangeCheckbox: function onChangeCheckbox(e) {
            return _this2.setCondition(e.target.value, item.type);
          }
        }), checked && (showCalendar ? (0, _preact.h)(_datePicker.default, {
          date: typeof data === 'string' ? new Date(data) : undefined,
          startDate: (0, _typeof2.default)(data) === 'object' && data.from ? new Date(data.from) : undefined,
          endDate: (0, _typeof2.default)(data) === 'object' && data.to ? new Date(data.to) : undefined,
          flex: true,
          placeholder: item.type === 'range' ? 'MM/DD/YYYY - MM/DD/YYYY' : 'MM/DD/YYYY',
          dateRange: item.type === 'range',
          onDateChange: function onDateChange(date) {
            return _this2.setData(date.toISOString(), item);
          },
          onDateRangeChange: function onDateRangeChange(dates) {
            return _this2.setData(DateFilterSelector.getIsoDateRange(dates), item);
          }
        }) : (0, _preact.h)(_InputGroup.default, {
          inline: true,
          name: name,
          value: typeof data === 'number' || typeof data === 'string' ? data : undefined,
          title: DateFilterSelector.getSubInputTitle(item.unit),
          type: "number",
          min: 0,
          formGroupClasses: "overview__filters-data-input",
          onKeyUp: function onKeyUp(e) {
            if ((0, _typeGuards.hasValueInEventTarget)(e)) {
              _this2.setData(e.target.value, item);
            }
          },
          onChange: function onChange(e) {
            return _this2.setData(e.target.value, item);
          }
        })));
      })), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: _objectSpread({}, this.state),
        isApplyButtonDisabled: !condition || !data || condition === 'range' && (0, _typeof2.default)(data) === 'object' && data.to === undefined
      }));
    }
  }], [{
    key: "getIsoDateRange",
    value: function getIsoDateRange(dates) {
      var _dates$from, _dates$to;

      return {
        from: (_dates$from = dates.from) === null || _dates$from === void 0 ? void 0 : _dates$from.toISOString(),
        to: (_dates$to = dates.to) === null || _dates$to === void 0 ? void 0 : _dates$to.toISOString()
      };
    }
  }]);
  return DateFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(DateFilterSelector, "create", function (config) {
  return _objectSpread({
    component: DateFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(state) {
      return _getPillDisplayValue(state, config.items);
    }
  }, config);
});
(0, _defineProperty2.default)(DateFilterSelector, "getSubInputTitle", function (itemUnit) {
  return "".concat(itemUnit, "s ago");
});
var _default = DateFilterSelector;
exports.default = _default;